import React, { useCallback } from 'react';
import { subscribeAdminNotifications } from '../../utils/notifications';
import NotificationBell from '../NotificationBell';

export default function AdminNotifications() {
  const subscribe = useCallback((cb) => subscribeAdminNotifications(cb), []);
  return <NotificationBell subscribe={subscribe} variant="light" />;
}
